// extracted by mini-css-extract-plugin
export default {"rotating":"component_rotating__7pljW"};